import {Locational} from "./integration/representation/feature";
import {FeatureModel} from "./integration/representation/viewmodel";


export function getRefLink(locational: Locational): string {
    if (locational.position) {
        return locational.position + "@" + locational.linkId;
    } else {
        return locational.from + "-" + locational.to + "@" + locational.linkId;
    }
}

export function noLocationals(feature: FeatureModel) {
    if (feature.locational === undefined
        || feature.locational.locationals === undefined
        || feature.locational.locationals.length === 0) {
        return true;
    }
}
